var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0 32px"},attrs:{"brezel-component-id":_vm.component.id}},[_c('FileSelect',{attrs:{"module":_vm.componentModule,"with-upload":_vm.options.with_upload || false,"with-upload-small":_vm.options.with_upload_small,"directory":_vm.directory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }